import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import GoalIcon from "@atlaskit/icon/core/goal";
import GridIcon from "@atlaskit/icon/core/grid";
import LightbulbIcon from "@atlaskit/icon/core/lightbulb";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";

import { tabbedHeroSectionPrioritizeMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type PrioritizeContentTypeProps = TabProps;

export const PrioritizeContentType: TabType =
    ({}: PrioritizeContentTypeProps) => {
        const intl = useIntl();
        const { createAnalyticsEvent } = useAnalyticsEvents();
        const { user } = useUserContext();

        return (
            <ContentTypeImage
                imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/68qe62s0jlq27ca036c8bj6kg6albvgt.webp"
                imageAlt="This is an image of Jira Product Discovery with a list of ideas and how they are priorized by impact and effort."
                title={intl.formatMessage(
                    tabbedHeroSectionPrioritizeMessages.contentTitle
                )}
                description={intl.formatMessage(
                    tabbedHeroSectionPrioritizeMessages.contentDescription
                )}
                hideSeparator={true}
                iconCollection={[
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionPrioritizeMessages.contentFeaturePoint1
                        ),
                        icon: <GoalIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionPrioritizeMessages.contentFeaturePoint2
                        ),
                        icon: <LightbulbIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionPrioritizeMessages.contentFeaturePoint3
                        ),
                        icon: <GridIcon label="" />
                    }
                ]}
                cta={
                    <Link
                        href={"/software/jira/product-discovery"}
                        text={intl.formatMessage(
                            tabbedHeroSectionPrioritizeMessages.contentCta
                        )}
                        type={"primary"}
                        dataEventProps={{
                            "data-product-key": "jiraProductDiscovery",
                            "data-event-component": "linkButton",
                            "data-event-container": "tabsMenu",
                            "data-event": "clicked",
                            "data-label": "try-it-out",
                            "data-label-english":
                                "Explore Jira Product Discovery",
                            "data-track-event":
                                "jpd-pt.content-types.prioritize-ideas.cta"
                        }}
                        onClick={() => {
                            createAnalyticsEvent({
                                eventName: "jpd-crossflow-tab-cta-clicked",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "linkButton",
                                actionSubjectId: "jpdCrossFlowHeroSection",
                                attributes: {
                                    reactComponent: "PrioritizeContentType",
                                    tab: "prioritize-ideas",
                                    userTeamType:
                                        user.extended_profile?.team_type
                                }
                            }).fire();
                        }}
                    />
                }
                reverseLayout
            />
        );
    };
